/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Transaction execution status */
export enum TransactionStatus {
  Pending,
  PartiallyApproved,
  FullyApproved,
  Executed,
  Cancelled,
  Expired,
  Failed,
}

export type TransactionStatusArgs = TransactionStatus;

export function getTransactionStatusEncoder(): FixedSizeEncoder<TransactionStatusArgs> {
  return getEnumEncoder(TransactionStatus);
}

export function getTransactionStatusDecoder(): FixedSizeDecoder<TransactionStatus> {
  return getEnumDecoder(TransactionStatus);
}

export function getTransactionStatusCodec(): FixedSizeCodec<
  TransactionStatusArgs,
  TransactionStatus
> {
  return combineCodec(
    getTransactionStatusEncoder(),
    getTransactionStatusDecoder(),
  );
}
